import validate from "/usr/src/app/node_modules/.pnpm/nuxt@4.4.8_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@babel+plugin-syntax-typ_b68365f38e9c67acc95c95bb80bfc1fa/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45redirect_45trailing_45slash_45global from "/usr/src/app/apps/site-sk/app/middleware/01.redirect-trailing-slash.global.ts";
import _02_45session_45global from "/usr/src/app/apps/site-sk/app/middleware/02.session.global.ts";
import _03_45tracking_45global from "/usr/src/app/apps/site-sk/app/middleware/03.tracking.global.ts";
import manifest_45route_45rule from "/usr/src/app/node_modules/.pnpm/nuxt@4.4.8_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@babel+plugin-syntax-typ_b68365f38e9c67acc95c95bb80bfc1fa/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  _01_45redirect_45trailing_45slash_45global,
  _02_45session_45global,
  _03_45tracking_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "account-guard": () => import("/usr/src/app/apps/site-sk/app/middleware/account-guard.ts"),
  auth: () => import("/usr/src/app/apps/site-sk/app/middleware/auth.ts")
}